export default "__VITE_ASSET__BkPP9N8p__"